var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acr-title"},[_c('h1',[_vm._v("资产类型管理")]),_c('el-button',{staticClass:"acr-title-add-button",attrs:{"type":"primary"},on:{"click":_vm.openEditPropertyType}},[_vm._v(" 新增资产类型 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }